import { classes } from 'utils/style';
import styles from './Tag.module.css';

export const Tag = ({
  children,
  size = 's',
  className,
  ...rest
}) => {
  return (
    <span
      className={classes(styles.tag, className)}
      data-size={size}
      {...rest}
    >
      {children}
    </span>
  );
};
